import { useQuery } from 'convex/react';
import { api } from '@convex/_generated/api';
import { Button } from '@ui/Button';
import { ConfirmationDialog } from '@ui/ConfirmationDialog';
import { useEffect, useState } from 'react';

export function ConvexOAuthPromptModal() {
  const hasConnected = useQuery(api.sessions.hasConnectedConvexOAuth);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Only show if the query has finished loading and returned false
    if (hasConnected === false) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [hasConnected]);

  const handleConnect = () => {
    // Open the connect flow in a popup
    const width = 600;
    const height = 800;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    
    window.open(
      '/convex/connect',
      'Convex OAuth',
      `width=${width},height=${height},left=${left},top=${top}`
    );
  };

  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmationDialog
      onClose={() => setIsOpen(false)}
      onConfirm={async () => {
        handleConnect();
      }}
      confirmText="Connect Convex Account"
      dialogTitle="Connect Your Convex Account"
      dialogBody={
        <div className="flex flex-col gap-4 mt-4">
          <p className="text-content-secondary mb-2">
            To create and deploy projects with Chef, you need to connect your Convex account. This allows Chef to provision deployments on your behalf.
          </p>
        </div>
      }
    />
  );
}
